import React from 'react';
import TutorialModal from '../TutorialModal/TutorialModal';
import PlayerFactionIcon from '../../PlayerFactionIcon/PlayerFactionIcon';
import {FACTIONS} from '../../../constants/factions';
import {InlineTokenIcon, LegendRow} from "./chapter1Modals";

/**
 * Обучающие модалки главы 2 (фракции, спецстроения, снабжение, инициатива,
 * новый город и зона влияния кварталов).
 * Формат и стиль — как в chapter1Modals; идентификаторы — в
 * tutorialModalsRegistry.
 */

export const Ch2WelcomeModal = () => (
  <TutorialModal title={'Глава 2: война с Орками'} buttonText={'Начать главу'}>
    <p>
      Прошло время: твой народ отстроил город и захватил соседний. Но с севера
      пришли <b>Орки</b>. А их рейдер подобрался к твоему городу с восточных границ.
    </p>
    <p>
      В этой партии у каждой стороны есть <b>фракция</b> со своим бонусом:
    </p>
    <LegendRow
      icon={<PlayerFactionIcon
        player={{color: 'blue'}}
        factionId={FACTIONS.HUMANS}
        className={'tutorial-modal_faction-icon'}
      />}
      iconBoxClassName={'card-icon'}
      label={<>
        <b>Люди</b> (ты) — скидка на политики; политика начинает работать сразу после покупки, даже если у игрока уже была
        политика.
        <br/>Но о политиках расскажем в 3 главе Обучения.
      </>}
    />
    <LegendRow
      icon={<PlayerFactionIcon
        player={{color: 'red'}}
        factionId={FACTIONS.ORCS}
        className={'tutorial-modal_faction-icon'}
      />}
      iconBoxClassName={'card-icon'}
      label={<>
        <b>Орки</b> — стойкость: за каждые полученные <span className={'text-war'}>3 урона</span><InlineTokenIcon src={'/img/icons/damage.png'} alt={'Урон'}/> отряды орков теряют лишь 2 размера<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>.
    </>}
    />
    <p>
      В этой главе освоим <span className={'text-construction'}>специальные строения</span>, нехватку <span
      className={'text-supply'}
    >снабжения</span>, <span className={'text-success'}>перехват инициативы</span> и основание <span
      className={'text-construction'}
    >новых городов</span>.
    </p>
  </TutorialModal>
);

export const Ch2RulesHintModal = () => (
  <TutorialModal title={'Полные правила — всегда под рукой'}>
    <p>
    </p>

    <LegendRow
      src={'/img/icons/rules.png'}
      label={<>
        <b>Полный текст Правил</b> доступен в главном меню.
        <br/>В матче Правила можно открыть в <b>меню матча</b> — кнопка меню справа в шапке.
      </>}
    />

    <LegendRow
      src={'/img/icons/banner.png'}
      label={<>
        В разделе <b>«Фракции»</b> можно подробно ознакомиться с каждой фракцией Стратегикона.
      </>}
    />
    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Открой меню матча и нажми «Правила».
      <br/> Перейди в раздел <InlineTokenIcon src={'/img/icons/banner.png'} alt={'Фракция'}/><b>«Фракции»</b>
      и <b>пролистай страницу вниз</b> — фракций много, все они ниже первого экрана.
    </>}
    />
  </TutorialModal>
);

export const Ch2FactionCardsModal = () => (
  <TutorialModal title={'Карточки фракций игроков'}>
    <LegendRow
      src={'/img/icons/banner.png'}
      label={<>
        Карточку фракции <b>каждого игрока</b> можно открыть в списке игроков — он открывается нажатием на кружки
        игроков в шапке. Достаточно нажать на игрока в списке.
      </>}
    />

    <LegendRow
      icon={<PlayerFactionIcon
        player={{color: 'red'}}
        factionId={FACTIONS.ORCS}
        className={'tutorial-modal_faction-icon'}
      />}
      iconBoxClassName={'card-icon'}
      label={'Пока противник ходит, на кнопке завершения хода видна иконка его фракции — нажатие на неё тоже откроет карточку фракции противника.'}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Открой свою карточку Людей из панели игроков.
      <br/>Второй способ опробуем чуть позже — когда ходить будет противник.
    </>}
    />
  </TutorialModal>
);

export const Ch2SupplyShortageModal = () => (
  <TutorialModal title={'Снабжения не хватает!'}>
    <p>
      У тебя 4 отряда, а Ферма<InlineTokenIcon src={'/img/hexes/farm.699e6dfc.png'} alt={'Ферма'}/> всего одна — она даёт
      лишь
      <b> одну</b> единицу снабжения<InlineTokenIcon
      src={'/img/icons/supply.png'} alt={'Снабжение'}
    />. То есть позволяет прокормить только 1 отряд.
    </p>
    <LegendRow
      src={'/img/icons/supply.png'} label={<>
      Напомню: отряд <span className={'text-war'}>без снабжения теряет 2 размера</span><InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/> в конце <span
      className={'text-supply'}
    >фазы Снабжения</span>.
    </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Снабди отряд Тяжёлой пехоты<InlineTokenIcon
      src={'/img/icons/unit d10 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Тяжёлая пехота'}
    /> на казарме<InlineTokenIcon src={'/img/hexes/barracks.efab12f7.png'} alt={'Казарма'}/> — он получит +2 размера<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>.
      <br/><span className={'text-war'}>Остальные</span> в этом раунде будут голодать — <span className={'text-war'}>потеряют по 2 размера</span><InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>.
    </>}
    />
    <p>
      В <span className={'text-construction'}>фазе Строительства</span> мы это исправим: построим вторую Ферму и Склад, чтобы наши отряды не
      голодали в будущем.
    </p>
  </TutorialModal>
);

export const Ch2WarehouseModal = () => (
  <TutorialModal title={'Специальные строения: склад'}>
    <p>
      Пора познакомиться со <span className={'text-construction'}>Специальными строениями</span><InlineTokenIcon src={'/img/hexes/special buildings/special building.c496c562.png'} alt={'Специальное строение'}/> — это строения, которые дают сильные экономические и военные бонусы.
    </p>
    <p>
    </p>

    <LegendRow
      src={'/img/hexes/special buildings/special building.c496c562.png'}
      label={<>
        <span className={'text-construction'}>Специальные строения</span> ставятся поверх свободных <span className={'text-construction'}>Базовых кварталов</span><InlineTokenIcon src={'/img/hexes/quarter.f69660fa.png'} alt={'Базовый квартал'}/>.
      </>}
    />

    <LegendRow
      src={'/img/hexes/special buildings/warehouse.adf397b3.png'}
      label={<>
        Склад: <span className={'text-supply'}>каждая</span> смежная с ним Ферма<InlineTokenIcon
        src={'/img/hexes/farm.699e6dfc.png'} alt={'Ферма'}
      /> производит <span className={'text-supply'}>2</span><InlineTokenIcon
        src={'/img/icons/supply.png'} alt={'Снабжение'}
      /> вместо <span className={'text-supply'}>1</span><InlineTokenIcon
        src={'/img/icons/supply.png'} alt={'Снабжение'}
      />.
      </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Построй Склад<InlineTokenIcon src={'/img/hexes/special buildings/warehouse.adf397b3.png'} alt={'Склад'}/> на указанном <span
      className={'text-construction'}
    >Базовом квартале</span><InlineTokenIcon src={'/img/hexes/quarter.f69660fa.png'} alt={'Базовый квартал'}/> — вплотную к только что построенной Ферме<InlineTokenIcon
      src={'/img/hexes/farm.699e6dfc.png'} alt={'Ферма'}
    />: она начнёт производить <span
      className={'text-supply'}
    >2</span><InlineTokenIcon
      src={'/img/icons/supply.png'} alt={'Снабжение'}
    />.
    </>}
    />
  </TutorialModal>
);

export const Ch2EnemyInterceptedModal = () => (
  <TutorialModal title={'Противник перехватил инициативу!'}>
    <p>
      В свою <span className={'text-construction'}>фазу Строительства</span> Орки потратили 1 действие<InlineTokenIcon
      src={'/img/icons/action.png'} alt={'Действие фазы Строительства'}
    /> на <span
      className={'text-success'}
    >перехват инициативы</span> — теперь противник будет ходить первым, начиная с <span className={'text-war'}>фазы Войны</span> этого
      раунда.
    </p>
    <LegendRow
      src={'/img/icons/initiative.png'}
      label={<>
        Перехват инициативы стоит 1 действие<InlineTokenIcon
        src={'/img/icons/action.png'} alt={'Действие фазы Строительства'}
      /> в <span className={'text-construction'}>фазе Строительства</span>.
        <br/>Инициативу <span className={'text-war'}>нельзя перехватить</span>, если другой игрок уже сделал это в текущем раунде.
      </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Закрой подсказку и смотри внимательно: рейдер Орков пойдёт к твоему <span
      className={'text-coins-dark'}
    >Руднику</span><InlineTokenIcon src={'/img/hexes/mine.ecae90cd.png'} alt={'Рудник'}/>.
    </>}
    />
  </TutorialModal>
);

export const Ch2MineBlockedModal = () => (
  <TutorialModal title={'Рудник заблокирован'}>
    <p>
      Рейдер уничтожил твой отряд и встал вплотную к <span
      className={'text-coins-dark'}
    >Руднику</span><InlineTokenIcon src={'/img/hexes/mine.ecae90cd.png'} alt={'Рудник'}/> и <span
      className={'text-construction'}
    >Базовому кварталу</span><InlineTokenIcon src={'/img/hexes/quarter.f69660fa.png'} alt={'Базовый квартал'}/>.
    </p>
    <LegendRow
      src={'/img/icons/block red outline.png'}
      label={<>
        Он <span className={'text-war'}>заблокировал</span> их — пока отряд противника не отойдёт или не будет уничтожен,
        они <span className={'text-war'}>не работают</span>.
    </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Твои отряды сейчас слишком слабые, чтобы ответить Оркам.
      <br/>Заверши этапы своего хода.
      <br/>В следующем раунде ты обязательно отомстишь!
    </>}
    />
  </TutorialModal>
);

export const Ch2FarmChainModal = () => (
  <TutorialModal title={'Снабжение: дальность и цепочки'}>
    <LegendRow
      src={'/img/icons/supply.png'} label={<>
      <span className={'text-supply'}>Путь снабжения</span> от Фермы<InlineTokenIcon
      src={'/img/hexes/farm.699e6dfc.png'} alt={'Ферма'}
    /> до отряда<InlineTokenIcon
      src={'/img/icons/unit d6 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Пехота'}
    /> дотягивается на <span className={'text-supply'}>5 ячеек</span>, но обязательно должен проходить <span
      className={'text-supply'}
    >по непустым ячейкам</span>!
      <br/>При этом сам отряд может быть на пустой ячейке<InlineTokenIcon
      src={'/img/icons/cell.png'} alt={'Ячейка'}
    />.
    </>}
    />
    <LegendRow
      src={'/img/hexes/farm.699e6dfc.png'} label={<>
      Своя Ферма на пути снабжения <span className={'text-supply'}>обнуляет счётчик дальности</span> — фермы могут
      передавать <span className={'text-supply'}>снабжение по цепочке</span>.
    </>}
    />
    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Теперь твои фермы произвели <span className={'text-supply'}>3</span><InlineTokenIcon
      src={'/img/icons/supply.png'} alt={'Снабжение'}
    /> — снабди все 3 отряда.
    </>}
    />
  </TutorialModal>
);

export const Ch2ArsenalModal = () => (
  <TutorialModal title={'Специальные строения: арсенал'}>
    <p>
      Пора готовить возмездие.
    </p>
    <LegendRow
      src={'/img/hexes/special buildings/arsenal.7f5423b5.png'} label={
      <>
        <span className={'text-construction'}>Арсенал</span> усиливает найм<InlineTokenIcon
        src={'/img/icons/coins.png'} alt={'Цена найма размера'}
      /> размера<InlineTokenIcon
        src={'/img/icons/unit size.png'} alt={'Размер отряда'}
      />:
        <br/>каждая докупка с <span className={'text-construction'}>квартала</span> даёт <b>+2</b><InlineTokenIcon
        src={'/img/icons/unit size.png'} alt={'Размер отряда'}
      /> отряду вместо +1<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>.
      </>
    }
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Построй <span className={'text-construction'}>Арсенал</span><InlineTokenIcon src={'/img/hexes/special buildings/arsenal.7f5423b5.png'} alt={'Арсенал'}/> на свободном <span className={'text-construction'}>Базовом квартале</span><InlineTokenIcon src={'/img/hexes/quarter.f69660fa.png'} alt={'Базовый квартал'}/> своего
      южного города<InlineTokenIcon
      src={'/img/icons/city.42008716.png'} alt={'Город'}
    />.
    </>}
    />
  </TutorialModal>
);

export const Ch2InterceptModal = () => (
  <TutorialModal title={'Перехвати инициативу сам'}>
    <p>
      Ответим Оркам их же оружием: <span className={'text-success'}>перехвати инициативу</span>, чтобы в <span
      className={'text-war'}
    >фазе Войны</span> ходить <b>первым</b> — атаковать до того, как противник успеет что-то предпринять.
    </p>
    <LegendRow
      src={'/img/icons/initiative.png'}
      label={<>
        Кнопка <span className={'text-success'}>перехвата инициативы</span><InlineTokenIcon
        src={'/img/icons/action initiative not active.png'} alt={'Действие перехвата инициативы'}
      /> находится в нижней панели.
        Она доступна только в <span className={'text-construction'}>фазе Строительства</span> и тратит 1 действие<InlineTokenIcon
        src={'/img/icons/action.png'} alt={'Действие фазы Строительства'}
      />.
      </>}
    />
  </TutorialModal>
);

export const Ch2RevengePlanModal = () => (
  <TutorialModal title={'План возмездия'}>
    <p>
      Рейдер Орков отрезан от своих ферм — без снабжения он уже <span
      className={'text-war'}
    >потерял 4 размера<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/></span>.
      <br/>Голод ослабляет любую армию: помни об этом и в своих походах.
    </p>

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Подведи Тяжёлую пехоту<InlineTokenIcon
      src={'/img/icons/unit d10 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Тяжёлая пехота'}
    /> вплотную к рейдеру, чтобы вступить в <span className={'text-war'}>ближний бой</span>.
    </>}
    />
  </TutorialModal>
);

export const Ch2OrcResilienceModal = () => (
  <TutorialModal title={'Стойкость Орков'}>
    <p>
      Рейдер уничтожен!
      <br/>Обрати внимание, твой отряд нанёс <span
      className={'text-war'}
    >10</span><InlineTokenIcon src={'/img/icons/damage.png'} alt={'Урон'}/>
      — этого хватает для уничтожения отряда Орков размера<InlineTokenIcon
      src={'/img/icons/unit size.png'} alt={'Размер отряда'}
    /> 6.
      <br/>Если бы было меньше <span
      className={'text-war'}
    >9</span><InlineTokenIcon src={'/img/icons/damage.png'} alt={'Урон'}/> — не хватило бы из-за особенной стойкости Орков: они теряют только 2<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/> за
      каждые <span className={'text-war'}>3</span><InlineTokenIcon src={'/img/icons/damage.png'} alt={'Урон'}/>.
    </p>
    <LegendRow src={'/img/icons/damage.png'} label={'Против Орков закладывай примерно в полтора раза больше урона!'}/>
    <LegendRow
      src={'/img/hexes/mine.ecae90cd.png'} label={<>
      <span className={'text-coins-dark'}>Рудник</span> снова работает и приносит доход<InlineTokenIcon
      src={'/img/icons/coins.png'} alt={'Монеты'}
    />!
    </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Заверши этапы своего хода.
    </>}
    />
  </TutorialModal>
);

export const Ch2DeepRaidModal = () => (
  <TutorialModal title={'Рейд без снабжения'}>
    <p>
      Кавалерия<InlineTokenIcon
      src={'/img/icons/unit d12 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Тяжёлая кавалерия'}
    /> ушла ещё на ячейку — и <span className={'text-supply'}>снабжение</span><InlineTokenIcon
      src={'/img/icons/supply.png'} alt={'Снабжение'}
    /> теперь до неё <span className={'text-war'}>уже не дотянется</span>: на пути есть пустая ячейка, через
      которую <span className={'text-supply'}>путь снабжения</span> пройти не может.
      В конце <span className={'text-supply'}>фазы Снабжения</span> кавалерия <span className={'text-war'}>потеряет 2 размера</span><InlineTokenIcon
      src={'/img/icons/unit size.png'} alt={'Размер отряда'}
    />.
    </p>
    <LegendRow src={'/img/icons/unit size.png'} label={'Глубокий рейд планируй с запасом размера!'}/>
    <p>
      Мы запас заложили: сил взять город хватит.
    </p>

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Снабди отряды, до которых снабжение достаёт.
    </>}
    />
  </TutorialModal>
);

export const Ch2CavalryToBarracksModal = () => (
  <TutorialModal title={'Казарма для кавалерии'}>
    <p>
      Кавалерия<InlineTokenIcon
      src={'/img/icons/unit d12 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Тяжёлая кавалерия'}
    /> голодала и ослабла.
    </p>
    <p>
      Вне Казармы<InlineTokenIcon
      src={'/img/hexes/barracks.efab12f7.png'} alt={'Казарма'}
    /> снабжение<InlineTokenIcon src={'/img/icons/supply.png'} alt={'Снабжение'}/> прибавляет ей
      лишь <b>1</b><InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/> за раунд.
    </p>
    <p>
      Быстро восстановить отряд можно только на Казарме<InlineTokenIcon
      src={'/img/hexes/barracks.efab12f7.png'} alt={'Казарма'}
    />:
      <br/>там снабжённый<InlineTokenIcon src={'/img/icons/supply.png'} alt={'Снабжение'}/> отряд растёт
      на <b>2</b><InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>.
    </p>

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Перемести кавалерию<InlineTokenIcon
      src={'/img/icons/unit d12 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Тяжёлая кавалерия'}
    /> на новую казарму<InlineTokenIcon src={'/img/hexes/barracks.efab12f7.png'} alt={'Казарма'}/>.
    </>}
    />
    <p>
    </p>
  </TutorialModal>
);

export const Ch2BarracksGrowthModal = () => (
  <TutorialModal title={'Рост на казарме'}>
    <LegendRow
      src={'/img/icons/supply.png'}
      label={
        <>
          В этой <span className={'text-supply'}>фазе Снабжения</span> Кавалерия<InlineTokenIcon
          src={'/img/icons/unit d12 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Тяжёлая кавалерия'}
        /> вырастет на +2<InlineTokenIcon
          src={'/img/icons/unit size.png'} alt={'Размер отряда'}
        /> как любой отряд на Казарме<InlineTokenIcon src={'/img/hexes/barracks.efab12f7.png'} alt={'Казарма'}/>:
          3<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/> → 5<InlineTokenIcon
          src={'/img/icons/unit size.png'} alt={'Размер отряда'}
        />.
        </>
      }
    />
    <LegendRow
      src={'/img/hexes/special buildings/military camp.1216e2cd.png'}
      label={
        <>
          В <span className={'text-construction'}>фазе Строительства</span> построим рядом с казармой <span
          className={'text-construction'}
        >Лагерь</span> — он удваивает рост на <span className={'text-war'}>каждой</span> смежной Казарме<InlineTokenIcon
          src={'/img/hexes/barracks.efab12f7.png'} alt={'Казарма'}
        /> в <span className={'text-supply'}>фазе Снабжения</span>:
          <br/>+4<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/> вместо +2<InlineTokenIcon
          src={'/img/icons/unit size.png'} alt={'Размер отряда'}
        />.
        </>
      }
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Снабди все 3 отряда.
    </>}
    />
  </TutorialModal>
);

export const Ch2CampGrowthModal = () => (
  <TutorialModal title={'Лагерь в деле'}>
    <p>
      Сравни рост за прошедшую фазу Снабжения:
    </p>
    <LegendRow
      src={'/img/hexes/special buildings/military camp.1216e2cd.png'}
      label={<>
        Кавалерия<InlineTokenIcon
        src={'/img/icons/unit d12 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Тяжёлая кавалерия'}
      /> на казарме<InlineTokenIcon src={'/img/hexes/barracks.efab12f7.png'} alt={'Казарма'}/> у <span
        className={'text-construction'}
      >Лагеря</span>: 8 → 12 (+4<InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/>).
      </>}
    />
    <LegendRow
      src={'/img/hexes/special buildings/military camp.1216e2cd.png'}
      label={<>
        Пехота<InlineTokenIcon
        src={'/img/icons/unit d6 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Пехота'}
      /> на обычной казарме<InlineTokenIcon src={'/img/hexes/barracks.efab12f7.png'} alt={'Казарма'}/>: 1 → 3 (+2<InlineTokenIcon
        src={'/img/icons/unit size.png'} alt={'Размер отряда'}
      />).
      </>}
    />
    <p>
      Кавалерия<InlineTokenIcon
      src={'/img/icons/unit d12 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Тяжёлая кавалерия'}
    /> теперь имеет максимальный размер<InlineTokenIcon
      src={'/img/icons/unit size.png'} alt={'Размер отряда'}
    /> — пора в поход на город Орков.
    </p>
  </TutorialModal>
);

// Пустая ячейка со штриховкой зоны кварталов — как на поле и в правилах
const QuarterZoneIcon = ({hatchSrc, alt}) => (
  <div className={'tutorial-modal_quarter-zone-icon'} title={alt}>
    <img src={'/img/icons/cell.png'} alt={''} aria-hidden={'true'}/>
    <img src={hatchSrc} alt={alt}/>
  </div>
);

export const Ch2NewCityModal = () => (
  <TutorialModal title={'Новый город'}>
    <p>
      Пока кавалерия готовится к походу, займёмся стройкой: город<InlineTokenIcon
      src={'/img/icons/city.42008716.png'} alt={'Город'}
    /> можно не только захватить, но и <b>основать</b>.
    </p>
    <LegendRow
      src={'/img/icons/central quarter.7dd51bfd.png'}
      label={<>
        Новый город<InlineTokenIcon src={'/img/icons/city.42008716.png'} alt={'Город'}/> начинается с <span
        className={'text-construction'}
      >Центрального квартала</span><InlineTokenIcon
        src={'/img/icons/central quarter.7dd51bfd.png'} alt={'Центральный квартал'}
      /> за <span className={'text-coins-dark'}>4 монеты</span><InlineTokenIcon src={'/img/icons/coins.png'} alt={'Монеты'}/>.
        <br/>Новый город — это новые ключевые точки, кварталы для докупки размера и места под специальные строения.
      </>}
    />
    <LegendRow
      src={'/img/hexes/road.1f281346.png'}
      label={<>
        Как и любое строение, квартал ставится в конце <span className={'text-construction'}>пути строительства</span> —
        непрерывного пути от любого твоего квартала по непустым ячейкам: дорогам, строениям и ключевым точкам.
      </>}
    />
    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      На западе лежат ничейные Великие руины<InlineTokenIcon src={'/img/hexes/super_ruins.97515170.png'} alt={'Великие руины'}/>.
      Проложи к ним Дорогу<InlineTokenIcon src={'/img/hexes/road.1f281346.png'} alt={'Дорога'}/> от Великого
      рудника<InlineTokenIcon src={'/img/hexes/super_mine.7a4a81f7.png'} alt={'Великий рудник'}/> — она продлит путь
      строительства к месту под новый город.
    </>}
    />
  </TutorialModal>
);

export const Ch2QuarterZoneModal = () => (
  <TutorialModal title={'Зона влияния кварталов'}>
    <LegendRow
      src={'/img/hexes/quarter.f69660fa.png'}
      label={<>
        Между кварталами<InlineTokenIcon src={'/img/hexes/quarter.f69660fa.png'} alt={'Квартал'}/> <b>разных</b> городов<InlineTokenIcon
        src={'/img/icons/city.42008716.png'} alt={'Город'}
      /> должно быть не меньше <b>2 ячеек</b>. Это касается и твоих собственных городов: новый город нельзя заложить
        вплотную к старому.
      </>}
    />
    <p>
      В <span className={'text-construction'}>фазе Строительства</span> зона влияния кварталов заштрихована на поле:
    </p>
    <LegendRow
      icon={<QuarterZoneIcon hatchSrc={'/img/icons/quarter_zone.png'} alt={'Зона влияния кварталов'}/>}
      label={<>
        Частая штриховка — <span className={'text-war'}>нельзя построить</span> ни Центральный<InlineTokenIcon
        src={'/img/icons/central quarter.7dd51bfd.png'} alt={'Центральный квартал'}
      />, ни Базовый квартал<InlineTokenIcon src={'/img/hexes/quarter.f69660fa.png'} alt={'Базовый квартал'}/>.
      </>}
    />
    <LegendRow
      icon={<QuarterZoneIcon hatchSrc={'/img/icons/base_quarter_allowed.png'} alt={'Можно построить Базовый квартал'}/>}
      label={<>
        Редкая штриховка — новый город основать <span className={'text-war'}>нельзя</span>, но <span
        className={'text-success'}
      >можно</span> расширить соседний: построить Базовый квартал<InlineTokenIcon
        src={'/img/hexes/quarter.f69660fa.png'} alt={'Базовый квартал'}
      />.
      </>}
    />
    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Дорога<InlineTokenIcon src={'/img/hexes/road.1f281346.png'} alt={'Дорога'}/> вывела путь строительства за
      штриховку. Основай город — построй <span className={'text-construction'}>Центральный квартал</span><InlineTokenIcon
      src={'/img/icons/central quarter.7dd51bfd.png'} alt={'Центральный квартал'}
    /> на указанной ячейке.
    </>}
    />
  </TutorialModal>
);

export const Ch2NewCityQuarterModal = () => (
  <TutorialModal title={'Кварталы нового города'}>
    <p>
      Город<InlineTokenIcon src={'/img/icons/city.42008716.png'} alt={'Город'}/> основан! Вокруг его кварталов появилась
      своя зона влияния.
    </p>
    <LegendRow
      src={'/img/hexes/quarter.f69660fa.png'}
      label={<>
        <span className={'text-construction'}>Базовый квартал</span> строится только вплотную к <span
        className={'text-construction'}
      >Центральному кварталу</span><InlineTokenIcon
        src={'/img/icons/central quarter.7dd51bfd.png'} alt={'Центральный квартал'}
      /> своего города — и тоже не ближе 2 ячеек к кварталам других городов.
        <br/>Поэтому в сторону соседнего города новый город не расширить: там частая штриховка.
      </>}
    />
    <LegendRow
      src={'/img/hexes/super_ruins.97515170.png'}
      label={<>
        Ключевые точки рядом с кварталами принадлежат городу<InlineTokenIcon
        src={'/img/icons/city.42008716.png'} alt={'Город'}
      />. <b>Великие руины</b> приносят <span
        className={'text-win-points-dark'}
      >4 очка</span><InlineTokenIcon src={'/img/icons/win points.png'} alt={'Очки'}/> в конце каждого раунда.
      </>}
    />
    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Третьим действием<InlineTokenIcon src={'/img/icons/action.png'} alt={'Действие фазы Строительства'}/> построй
      Базовый квартал<InlineTokenIcon src={'/img/hexes/quarter.f69660fa.png'} alt={'Базовый квартал'}/> на указанной
      ячейке — у Великих руин<InlineTokenIcon src={'/img/hexes/super_ruins.97515170.png'} alt={'Великие руины'}/>.
    </>}
    />
  </TutorialModal>
);

export const Ch2SteppeStepModal = () => (
  <TutorialModal title={'Перемещение по пустым ячейкам'}>
    <LegendRow
      src={'/img/icons/cell.png'}
      label={<>
        Скорость<InlineTokenIcon src={'/img/icons/speed.png'} alt={'Размер отряда'}/> кавалерии<InlineTokenIcon
        src={'/img/icons/unit d12 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Тяжёлая кавалерия'}
      /> — 4 ячейки, но перемещение <b>не проходит сквозь пустые ячейки</b>: встав на пустую ячейку, отряд сразу
        останавливается, независимо от скорости.
      </>}
    />
    <LegendRow
      src={'/img/icons/speed.png'}
      label={<>
        Через пустые ячейки<InlineTokenIcon src={'/img/icons/cell.png'} alt={'Пустая ячейка'}/> к городу<InlineTokenIcon
        src={'/img/icons/city.42008716.png'} alt={'Город'}
      /> Орков кавалерия<InlineTokenIcon
        src={'/img/icons/unit d12 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Тяжёлая кавалерия'}
      /> пойдёт по одной ячейке за раунд.
      </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Заверши найм и сделай первый шаг — на указанную пустую ячейку.
    </>}
    />
  </TutorialModal>
);

export const Ch2SupplyToEmptyModal = () => (
  <TutorialModal title={'Снабжение на пустую ячейку'}>
    <p>
    </p>

    <LegendRow
      src={'/img/icons/supply.png'}
      label={<>
        Кавалерия<InlineTokenIcon
        src={'/img/icons/unit d12 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Тяжёлая кавалерия'}
      /> стоит на пустой ячейке<InlineTokenIcon src={'/img/icons/cell.png'} alt={'Пустая ячейка'}/>, но <span
        className={'text-supply'}
      >путь снабжения</span> <b>до неё</b> идёт по
        непустым — дорога, квартал, казарма. Сам отряд может стоять на пустой ячейке: снабжение дотянется.
      </>}
    />
    <LegendRow
      src={'/img/icons/exclamation-mark.png'}
      label={<>
        По пустым ячейкам<InlineTokenIcon src={'/img/icons/cell.png'} alt={'Пустая ячейка'}/> <span className={'text-war'}>не может</span> проходить
        сам <span className={'text-supply'}>путь снабжения</span> — до отряда невключительно.
      </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Снабди все четыре отряда.
    </>}
    />
  </TutorialModal>
);

export const Ch2PalaceModal = () => (
  <TutorialModal title={'Специальные строения: дворец'}>
    <p>
      <b>Дворец</b> — сердце большой империи!
    </p>
    <LegendRow
      src={'/img/hexes/special buildings/palace.4b9c923b.png'}
      label={<>
        <span className={'text-construction'}>Дворец</span> даёт +1 действие в <span className={'text-construction'}>фазе Строительства</span>.
      </>}
    />
    <LegendRow
      src={'/img/icons/win points.png'}
      label={<>
        За захват города<InlineTokenIcon src={'/img/icons/city.42008716.png'} alt={'Город'}/>с <span
        className={'text-construction'}
      >Дворцом</span> захватчик получает дополнительные <span
        className={'text-win-points-dark'}
      >4 очка</span><InlineTokenIcon
        src={'/img/icons/win points.png'} alt={'Очки'}
      /> (а бывший владелец — теряет).
      </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Построй <span className={'text-construction'}>Дворец</span><InlineTokenIcon src={'/img/hexes/special buildings/palace.4b9c923b.png'} alt={'Дворец'}/> на <span className={'text-construction'}>Базовом квартале</span><InlineTokenIcon
      src={'/img/hexes/quarter.f69660fa.png'} alt={'Базовый квартал'}
    /> северного города.
      <br/>А затем — казарму<InlineTokenIcon src={'/img/hexes/barracks.efab12f7.png'} alt={'Казарма'}/>: на ней будет
      восстанавливаться кавалерия.
    </>}
    />
  </TutorialModal>
);

export const Ch2CampModal = () => (
  <TutorialModal title={'Специальные строения: лагерь'}>
    <p>
      Теперь благодаря <span className={'text-construction'}>Дворцу</span><InlineTokenIcon src={'/img/hexes/special buildings/palace.4b9c923b.png'} alt={'Дворец'}/> у тебя <b>3 действия</b><InlineTokenIcon
      src={'/img/icons/action.png'} alt={'Размер отряда'}
    /> в <span className={'text-construction'}>фазе Строительства</span>.
    </p>
    <p>

    </p>
    <LegendRow
      src={'/img/hexes/special buildings/military camp.1216e2cd.png'}
      label={<>
        <span className={'text-construction'}>Лагерь</span> усиливает смежные казармы<InlineTokenIcon
        src={'/img/hexes/barracks.efab12f7.png'} alt={'Казарма'}
      />: отряды на каждой из них получают за снабжение<InlineTokenIcon
        src={'/img/icons/supply.png'} alt={'Снабжение'}
      /> по <b>+4</b><InlineTokenIcon src={'/img/icons/unit size.png'} alt={'Размер отряда'}/> вместо +2<InlineTokenIcon
        src={'/img/icons/unit size.png'} alt={'Размер отряда'}
      />.
      </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Построй <span className={'text-construction'}>Лагерь</span><InlineTokenIcon src={'/img/hexes/special buildings/military camp.1216e2cd.png'} alt={'Лагерь'}/> на указанной ячейке рядом с Казармой<InlineTokenIcon
      src={'/img/hexes/barracks.efab12f7.png'} alt={'Казарма'}
    />.
      <br/>Затем ещё один <span className={'text-construction'}>Базовый квартал</span><InlineTokenIcon
      src={'/img/hexes/quarter.f69660fa.png'} alt={'Базовый квартал'}
    /> и Ферму<InlineTokenIcon src={'/img/hexes/farm.699e6dfc.png'} alt={'Ферма'}/> — прямо под Тяжёлой пехотой, вплотную к <span className={'text-construction'}>Складу</span><InlineTokenIcon src={'/img/hexes/special buildings/warehouse.adf397b3.png'} alt={'Склад'}/>: обе смежные с ним фермы<InlineTokenIcon src={'/img/hexes/farm.699e6dfc.png'} alt={'Ферма'}/> будут давать по <span className={'text-supply'}>2</span><InlineTokenIcon
      src={'/img/icons/supply.png'} alt={'Снабжение'}
    />.
    </>}
    />
    <p>
    </p>
  </TutorialModal>
);

export const Ch2GarrisonBrokenModal = () => (
  <TutorialModal title={'Гарнизон разбит'}>

    <LegendRow
      src={'/img/icons/barracks red.png'} label={<>
      Смотри расчёт боя: Кавалерия<InlineTokenIcon
      src={'/img/icons/unit d12 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Тяжёлая кавалерия'}
    /> сминает гарнизон Орков — даже их стойкость
      не спасёт от такого удара.
      <br/>Город<InlineTokenIcon
      src={'/img/icons/city.42008716.png'} alt={'Город'}
    /> останется без защитников.
    </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Заверши этапы хода и готовься к захвату в следующем раунде.
    </>}
    />
  </TutorialModal>
);

export const Ch2CaptureCityModal = () => (
  <TutorialModal title={'Захват города противника'}>
    <p>
      Город<InlineTokenIcon src={'/img/icons/city.42008716.png'} alt={'Город'}/> захватывается, как и нейтральный: поставь отряд
      на любой <span className={'text-construction'}>квартал</span> города,
      в котором не осталось защитников, и дождись конца раунда.
    </p>
    <LegendRow
      src={'/img/icons/win points.png'}
      label={<>
        Чем богаче город<InlineTokenIcon src={'/img/icons/city.42008716.png'} alt={'Город'}/>, тем больнее его терять:
        <br/>владелец теряет очки<InlineTokenIcon src={'/img/icons/win points.png'} alt={'Очки'}/> за каждое строение,
        рудники и руины города — а ты столько же получаешь.
      </>}
    />

    <LegendRow
      src={'/img/icons/arrow_down_big.png'} label={<>
      Поставь кавалерию<InlineTokenIcon
      src={'/img/icons/unit d12 friend.png'} className={'tutorial-modal_inline-unit-icon'} alt={'Тяжёлая кавалерия'}
    /> на указанный <span className={'text-construction'}>Базовый квартал</span> Орков.
    </>}
    />
  </TutorialModal>
);
